<mat-tab-group>
  <mat-tab label="Elements">
    <stars-guide-elements></stars-guide-elements>
  </mat-tab>

  <mat-tab label="Anatomy">
    <stars-guide-anatomy></stars-guide-anatomy>
  </mat-tab>
</mat-tab-group>
